import React, { useEffect, useState } from 'react';
import './Styles/AnalyticsMain.css';
import SummaryVisit from '../../Components/AnalyticsMain/SummaryVisit';
import DistVisitByDay from '../../Components/AnalyticsMain/DistVisitByDay';
import { useLoadingState } from '../../context/LoadingContext';
import { DataApi } from '../../API';
import { useSelector } from 'react-redux';

function AnalyticsRealTime(props) {
  const currentSite = useSelector((state) => state.currentSite);
  const [, setLoading] = useLoadingState(true);
  const [PVData, setPVData] = useState({});
  const [UVData, setUVData] = useState({});
  const [graphData, setGraphData] = useState({});
  useEffect(() => {
    try {
      setLoading(true);
      const getApi = async () => {
        const { data } = await DataApi.getRealTimeData(currentSite.script_code);
        setGraphData({
          title: '실시간 방문분포',
          XAxis: 'time',
          info: {
            new_visitor: data.uvData?.summary[2]?.cur,
            re_visitor: data.uvData?.summary[3]?.cur,
            all_pv: data.pvData?.summary[0]?.cur,
            new_pv: data.pvData?.summary[1]?.cur,
            re_pv: data.pvData?.summary[2]?.cur,
          },
          graphData: data?.rows,
        });
        setPVData(data.pvData?.summary);
        setUVData(data.uvData?.summary);
      };
      getApi();
    } catch (e) {
      console.error(e.message);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [currentSite, setLoading]);
  props.setCurrentPage(props.pageTitle);
  return (
    <>
      <SummaryVisit
        data={{ PVData: PVData, UVData: UVData }}
        type={'realTime'}
      />
      <DistVisitByDay data={graphData} />
    </>
  );
}

export default AnalyticsRealTime;
